import React, { Dispatch, SetStateAction, useCallback, useState } from "react";
import { UsrFilterType } from "../../hooks/UseUserData";

type Props = {
  Search: (filter: UsrFilterType) => void;
};

function UserFilter({ Search }: Props) {
  const [isMarketing, setIsMarketing] = useState<boolean | undefined>(
    undefined
  );
  const [isProject, setIsProject] = useState<boolean | undefined>(undefined);
  const [text, setText] = useState<string>("");

  return (
    <form
      className="user-filter"
      onSubmit={(e) => {
        e.preventDefault();
        Search({ isMarketing, isProject, text });
      }}
    >
      <div className="left">
        {layout.map(({ title, type }, idx) => {
          return (
            <UsrFilterCard
              key={idx}
              title={title}
              idx={idx}
              type={type}
              isCheck={idx === 0 ? isProject : isMarketing}
              setIsCheck={idx === 0 ? setIsProject : setIsMarketing}
            />
          );
        })}
      </div>
      <div className="right">
        <div className="input-wrapper">
          <input
            type="text"
            placeholder="회원 검색"
            onChange={(e) => {
              setText(e.target.value);
            }}
          />
          <img src="/assets/common/search.svg" alt="" />
        </div>
        <button>검색</button>
      </div>
    </form>
  );
}

export default UserFilter;

const UsrFilterCard = ({
  title,
  idx,
  type,
  isCheck,
  setIsCheck,
}: {
  title: string;
  idx: number;
  type: string;
  isCheck: boolean | undefined;
  setIsCheck: Dispatch<SetStateAction<boolean | undefined>>;
}) => {
  return (
    <div className="check-box-wrapper">
      <div className="title">{title}</div>
      <div className="check-wrapper">
        <div
          className={`check ${isCheck ? "active" : ""}`}
          onClick={() => {
            setIsCheck(true);
          }}
        >
          {isCheck ? <img src="/assets/common/check.svg" alt="" /> : undefined}
        </div>
        <div className="title">{idx === 1 ? "동의" : "참여"}</div>
      </div>
      <div className="check-wrapper">
        <div
          className={`check ${isCheck === false ? "active" : ""}`}
          onClick={() => {
            setIsCheck(false);
          }}
        >
          {isCheck === false && <img src="/assets/common/check.svg" alt="" />}
        </div>
        <div className="title">{idx === 1 ? "미동의" : "미참여"}</div>
      </div>
      <div className="check-wrapper">
        <div
          className={`check ${isCheck === undefined ? "active" : ""}`}
          onClick={() => {
            setIsCheck(undefined);
          }}
        >
          {isCheck === undefined && (
            <img src="/assets/common/check.svg" alt="" />
          )}
        </div>
        <div className="title">전체</div>
      </div>
    </div>
  );
};

const layout = [
  {
    title: "프로젝트 참여 여부",
    type: "project",
  },
  {
    title: "마케팅 동의 여부",
    type: "marketing",
  },
];
